import { useQuery } from '@tanstack/react-query'
import { contentVersions } from '../../v3/contentVersions'
import { globalQueryKeys } from '../queryKeys'
import { flattenContentVersions } from './selectors'

/**
 * Reads the version history for a content, flattened newest first.
 *
 * No `staleTime`/`gcTime`: version history is an actively edited surface (labels
 * change here), so it must always refetch on mount and invalidate.
 */
export const useContentVersions = (contentUuid: string, enabled = true) =>
  useQuery({
    queryKey: globalQueryKeys.contentVersions(contentUuid),
    queryFn: () => contentVersions.readCollection({ contentUuid }),
    enabled,
    select: flattenContentVersions,
  })
